import { IonRow, IonCol } from '@ionic/react';
import React, { useEffect, useState, useRef } from 'react';
import { connect } from 'react-redux';
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Tab,
  Tabs,
  Link,
  Button,
} from '@material-ui/core';
import SuccessIcon from '@material-ui/icons/CheckCircleOutline';
import ErrorIcon from '@material-ui/icons/ErrorOutline';
import InfoRounded from '@material-ui/icons/InfoRounded';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { NavLink, useHistory, useLocation, useParams } from 'react-router-dom';
import { isIOS } from 'react-device-detect';
import axios from 'axios';
import ExpandLessSharpIcon from '@material-ui/icons/ExpandLessSharp';
import { RootState } from '../../models/RootState';
import {
  getAllMarketsByEvent,
  clearExchcngeBets,
  fetchOpenBets,
  fetchEvent,
  getSecondaryMarketsByEvent,
  setExchEvent,
  getSecondaryMatchOddsByEvent,
  updateEventScorecard,
  getCurrencyTypeFromToken,
  fetchPremiummarketsByEventId,
  getPremiumMarkets,
  getLineMarketsByEvent,
  getBookmakerMarketsByEvent,
  updateBookMakerMarkets,
  getSapTokenFromToken,
  getHouseIdFromToken,
  getParentIdFromToken,
  fetchBalance,
  getFancyMarketsByEvent,
} from '../../store';
import EventsListMenu from '../../components/ExchEventsListMenu/ExchEventsListMenu';
import BmMTable from '../../components/ExchBookmakerMarketTable/ExchBookmakerMarketTable';
import FMTable from '../../components/ExchFancyMarketsTable/ExchFancyMarketsTable';
import MatchOddsTable from '../../components/ExchMatchOddsTable/ExchMatchOddsTable';
import ExchBetslip from '../../components/ExchBetslip/ExchBetslip';
import ExchOpenBets from '../../components/ExchOpenBets/ExchOpenBets';
import CricketLiveStream from '../../components/Livestream/CricketLiveStream';
import { PlaceBetRequest } from '../../models/BsData';
import { UserBet } from '../../models/UserBet';
import TabPanel from '../../components/TabPanel/TabPanel';
import CompetitionsMenu from '../../components/ExchCompetitionsMenu/ExchCompetitionsMenu';
import {
  SecondaryMarkets,
  SelectedObj,
} from '../../models/ExchangeSportsState';
import {
  subscribeWsForEventOdds,
  subscribeWsForSecondaryMarkets,
  subscribeWsForSecondaryMatchOdds,
  unsubscribeAllWsforEvents,
  checkStompClientSubscriptions,
  subscribeSportRadarEventOdds,
  subscribeWsForFancyMarkets,
  disconnectToWS,
  isPushNotificationConnected,
  connectToPushNotification,
  disConnectToPushNotificationWS,
  subscribeWsForNotifications,
  checkPNStompClientSubscriptions,
  unsubscribePNWsforEvents,
  subscribeWsForNotificationsPerAdminAllMarkets,
  subscribeWsForNotificationsPerAdmin,
  connectToBFWS,
  connectToDreamWS,
  connectToSRWS,
} from '../../webSocket/webSocket';
import { EventDTO } from '../../models/common/EventDTO';
import { MatchOddsDTO } from '../../models/common/MatchOddsDTO';
import API from '../../api';
import { CURRENCY_TYPE_FACTOR } from '../../constants/CurrencyTypeFactor';
import { SPEventDTO } from '../../models/SPEventDTO';
import PremiumMarketsView from '../../components/PremiumMarkets/PremiumMarketsView';
import moment from 'moment';

import './ExchangeAllMarkets.scss';
import { BookmakerDTO } from '../../models/common/BookmakerDTO';
import SVLS_API from '../../api-services/svls-api';
import { PROVIDER_ID } from '../../constants/Branding';
import SEO from '../../components/SEO/Seo';
import { BRAND_NAME } from '../../constants/Branding';
import API_SPORT_FEED from '../../api-services/sportsfeed-api';
import {
  betStatus,
  clearBetStatusResponse,
  setBettingInprogress,
} from '../../store/exchBetslip/exchBetslipActions';
import { toast } from 'react-toastify';
import { BET_TIMEOUT } from '../../constants/CommonConstants';
import Script from 'next/script';
import { usePageVisibility } from '../../hooks/visibility.hook';
import { FancyMarketDTO } from '../../models/common/FancyMarketDTO';
type StoreProps = {
  selectedEvent: SelectedObj;
  eventData: EventDTO;
  bmMData: BookmakerDTO[];
  secondaryMatchOdds: MatchOddsDTO[];
  lineMarkets: MatchOddsDTO[];
  secondaryMarkets: SecondaryMarkets;
  bets: PlaceBetRequest[];
  openBets: UserBet[];
  totalOrders: number;
  loggedIn: boolean;
  selectedEventType: { id: ''; name: ''; slug: '' };
  clearExchcngeBets: () => void;
  fetchOpenBets: (eventId: string, sportId: string) => void;
  fetchEvent: (
    sportId: string,
    competitionId: string,
    eventId: string,
    marketTime: string
  ) => void;
  fetchPremiummarketsByEventId: (
    providerId: string,
    sportid: string,
    competitionId: string,
    eventId: string,
    marketTime: string
  ) => void;
  setExchEvent: (event: SelectedObj) => void;
  updateEventScorecard: (scorecard: any) => void;
  seEventData: SPEventDTO;
  topicUrls: any;
  houseId: string;
  parentId: string;
  accountId: string;
  triggerFetchMarkets: number;
  triggerFetchOrders: number;
  triggerBetStatus: number;
  betStatusResponse: any;
  clearExchangeBets: () => void;
  setBettingInprogress: (val: boolean) => void;
  clearBetStatusResponse: () => void;
  betFairWSConnected: boolean;
  dreamWSConnected: boolean;
  sportsRadarWSConnected: boolean;
  fmData: FancyMarketDTO[];
};

type RouteParams = {
  eventType: string;
  competition: string;
  eventId: string;
  eventInfo: string;
};

const ExchAllMarkets: React.FC<StoreProps> = (props) => {
  const {
    selectedEvent,
    eventData,
    secondaryMatchOdds,
    secondaryMarkets,
    bets,
    openBets,
    totalOrders,
    loggedIn,
    clearExchcngeBets,
    fetchOpenBets,
    selectedEventType,
    fetchEvent,
    fetchPremiummarketsByEventId,
    setExchEvent,
    updateEventScorecard,
    seEventData,
    bmMData,
    topicUrls,
    houseId,
    parentId,
    accountId,
    triggerFetchMarkets,
    triggerFetchOrders,
    triggerBetStatus,
    betStatusResponse,
    clearExchangeBets,
    setBettingInprogress,
    clearBetStatusResponse,
    betFairWSConnected,
    sportsRadarWSConnected,
    dreamWSConnected,
    fmData
  } = props;

  const isVisible = usePageVisibility();
  const routeParams = useParams<RouteParams>();
  const [tabVal, setTabVal] = useState(0);
  const [openBetslip, setOpenBetslip] = useState<boolean>(true);
  const [backupStreamUrl, setBackupStreamUrl] = useState<string>(null);
  const [fancyTabVal, setFancyTabVal] = useState(0);
  const [scorecardID, setScorecardID] = useState<string>('');
  const [virtualScorecard, setVirtualScorecard] = useState();
  const [cFactor, setCFactor] = useState<number>(
    CURRENCY_TYPE_FACTOR[getCurrencyTypeFromToken()]
  );
  const [exposureMap, setExposureMap] = useState(null);
  const [matchOddsBaseUrl, setMatchOddsBaseUrl] = useState<string>('');
  const [matchOddsTopic, setMatchOddsTopic] = useState<string>('');
  const [bookMakerBaseUrl, setBookMakerBaseUrl] = useState<string>('');
  const [bookMakerTopic, setBookMakerTopic] = useState<string>('');
  const [fancyBaseUrl, setFancyBaseUrl] = useState<string>('');
  const [fancyTopic, setFancyTopic] = useState<string>('');
  const [premiumBaseUrl, setPremiumBaseUrl] = useState<string>('');
  const [premiumTopic, setPremiumTopic] = useState<string>('');
  const [enableFetchOrders, setEnableFetchOrders] = useState<boolean>(false);
  const [startTime, setStartTime] = useState<Date>();
  const [fetchOpenOrders, setFetchOpenOrders] = useState<number>(null);
  const [addNewBet, setAddNewBet] = useState<boolean>(true);
  const intervalRef = useRef(null);
  const isFirstRender = useRef(true);
  const isFirstRenderVisibility = useRef(true);
  const isFirstRenderStartTime = useRef(true);

  const isMobile = window.innerWidth > 1120 ? false : true;

  const pathLocation = useLocation();

  let scorecardScript = {
    __html: `
          (function(a,b,c,d,e,f,g,h,i){a[e]||(i=a[e]=function(){(a[e].q=a[e].q||[]).push(arguments)},i.l=1*new Date,i.o=f,
          g=b.createElement(c),h=b.getElementsByTagName(c)[0],g.async=1,g.src=d,g.setAttribute("n",e),h.parentNode.insertBefore(g,h)
          )})(window,document,"script", "https://widgets.sir.sportradar.com/8ee45b574e2781d581b0b0a133803906/widgetloader", "SIR", {
              theme: false, // using custom theme
              language: "en"
          });
          SIR("addWidget", ".sr-widget-1", "match.lmtPlus", {layout: "double", scoreboard: "extended", momentum: "extended", collapseTo: "momentum", matchId:${scorecardID}});
            `,
  };

  useEffect(() => {
    unsubscribeAllWsforEvents();
  }, [selectedEvent]);

  useEffect(() => {
    if (!loggedIn) {
      unsubscribeAllWsforEvents();
    }
  }, [loggedIn]);

  useEffect(() => {
    if (loggedIn && eventData) {
      setCFactor(CURRENCY_TYPE_FACTOR[getCurrencyTypeFromToken()]);
      if (topicUrls?.matchOddsTopic) {
        updateMatchOddsTopic(
          topicUrls?.matchOddsTopic,
          topicUrls?.matchOddsBaseUrl
        );
        subscribeWsForEventOdds(
          topicUrls?.matchOddsTopic,
          eventData.sportId,
          eventData.competitionId,
          eventData.eventId,
          eventData.matchOdds.marketId,
          eventData.providerName,
          false
        );
      }

      if (eventData.sportId === '4' || eventData.sportId === '2' || eventData.sportId === '1') {
        if (secondaryMarkets?.bookmakers?.length && topicUrls?.bookMakerTopic) {
          updateBookMakerTopic(
            topicUrls?.bookMakerTopic,
            topicUrls?.bookMakerBaseUrl
          );
          for (let itm of secondaryMarkets?.bookmakers) {
            subscribeWsForSecondaryMarkets(
              topicUrls?.bookMakerTopic,
              eventData?.eventId,
              itm.marketId
            );
          }
        }
        if (topicUrls?.fancyTopic) {
          updateFancyTopic(topicUrls?.fancyTopic, topicUrls?.fancyBaseUrl);
          subscribeWsForFancyMarkets(topicUrls?.fancyTopic, eventData?.eventId);
        }
      }

      if (topicUrls?.matchOddsTopic) {
        updateMatchOddsTopic(
          topicUrls?.matchOddsTopic,
          topicUrls?.matchOddsBaseUrl
        );
        for (let mo of secondaryMatchOdds) {
          subscribeWsForSecondaryMatchOdds(
            topicUrls?.matchOddsTopic,
            eventData.eventId,
            mo.marketId,
            eventData.providerName
          );
        }
      }

      if (
        seEventData?.markets?.matchOdds &&
        seEventData?.markets?.matchOdds?.length > 0 &&
        topicUrls?.premiumTopic
      ) {
        updatePremiumTopic(topicUrls?.premiumTopic, topicUrls?.premiumBaseUrl);
        subscribeSportRadarEventOdds(
          topicUrls?.premiumTopic,
          selectedEvent?.id,
          seEventData.eventId
        );
      }
    }
  }, [
    betFairWSConnected,
    selectedEvent,
    loggedIn,
    secondaryMatchOdds,
    secondaryMarkets,
  ]);

  useEffect(() => {
    if (
      eventData?.eventId &&
      eventData?.status === 'IN_PLAY' &&
      scorecardID === ''
    ) {
      loggedIn && getSPEventIdByBetfairId();
      if (eventData.sportId === '4') {
        getVirtualScoreCard(eventData.eventId);
      }
    }
  }, [eventData?.eventId]);

  useEffect(() => {
    if (seEventData?.eventId && scorecardID === '') {
      loggedIn && setScorecardID(seEventData?.eventId?.split(':')[2]);
    }
  }, [seEventData]);

  const getVirtualScoreCard = async (eventId) => {
    try {
      const genieResponse = await axios.post(
        `https://api-genie.mysportsfeed.io/api/scorecard/`,
        { eventId: eventId, operatorId: '1' }
      );
      setVirtualScorecard(genieResponse.data.scoreUrl);
    } catch (err) {}
  };

  const updateMatchOddsTopic = (
    currentTopic: string,
    currentBaseUrl: string
  ) => {
    if (
      matchOddsTopic !== currentTopic ||
      matchOddsBaseUrl !== currentBaseUrl
    ) {
      disconnectToWS();
      setMatchOddsTopic(currentTopic);
      setMatchOddsBaseUrl(currentBaseUrl);
    }
  };

  const updateBookMakerTopic = (
    currentTopic: string,
    currentBaseUrl: string
  ) => {
    if (
      bookMakerTopic !== currentTopic ||
      bookMakerBaseUrl !== currentBaseUrl
    ) {
      disconnectToWS();
      setBookMakerTopic(currentTopic);
      setBookMakerBaseUrl(currentBaseUrl);
    }
  };

  const updateFancyTopic = (currentTopic: string, currentBaseUrl: string) => {
    if (fancyTopic !== currentTopic || fancyBaseUrl !== currentBaseUrl) {
      disconnectToWS();
      setFancyTopic(currentTopic);
      setFancyBaseUrl(currentBaseUrl);
    }
  };

  const updatePremiumTopic = (currentTopic: string, currentBaseUrl: string) => {
    if (premiumTopic !== currentTopic || premiumBaseUrl !== premiumBaseUrl) {
      disconnectToWS();
      setPremiumTopic(currentTopic);
      setPremiumBaseUrl(currentBaseUrl);
    }
  };

  const getSPEventIdByBetfairId = async () => {
    try {
      await API_SPORT_FEED.post(`/feed/get-sr-event-details`, {
        eventId: eventData?.eventId,
        token: getSapTokenFromToken(),
      }).then((result) => {
        if (result?.data?.status === 'RS_OK')
          setScorecardID(
            result?.data?.srEventDetails?.srEventId?.split(':')[2]
          );
        else setScorecardID(null);
      });
    } catch (err) {
      setScorecardID(null);
    }
  };

  useEffect(() => {
      if (['1', '2'].includes(eventData?.sportId)) setFancyTabVal(1);
      if (
        !secondaryMarkets?.fancyMarkets ||
        secondaryMarkets?.fancyMarkets?.length === 0
      ) {
        setFancyTabVal(1);
      } else {
        setFancyTabVal(0);
      }
    }, [secondaryMarkets]);
   

  useEffect(() => {
    updateEventScorecard(null);
  }, [eventData?.eventId]);

  useEffect(() => {
    clearExchcngeBets();
    return () => {
      setExchEvent({ id: '', name: '', slug: '' });
    };
  }, []);

  useEffect(() => {
    if (isFirstRenderVisibility.current) {
      isFirstRenderVisibility.current = false;
      return;
    }

    if (isVisible && loggedIn) {
      if (((eventData?.matchOdds?.runners?.length > 0 || secondaryMatchOdds?.length > 0) && !betFairWSConnected) ||
        ((bmMData?.length > 0 || fmData?.length > 0) && !dreamWSConnected) ||
        (seEventData?.markets?.matchOdds?.length > 0 && !sportsRadarWSConnected)) {
        let paramSId = null;
        let paramCId = null;
        let paramEId = null;
        let paramPName = null;
        const [sportId, competitionId, eventId, marketTime] = atob(
          routeParams.eventInfo ? routeParams.eventInfo : ''
        ).split(':');

        paramSId = sportId;
        paramCId = competitionId;
        paramEId = eventId;
        paramPName = 'BetFair';

        if (!eventId?.toLowerCase()?.includes('sr')) {
          fetchEvent(paramSId, paramCId, paramEId, marketTime);

          paramCId = competitionId.includes('_')
            ? competitionId.split('_').join(':')
            : competitionId;
          paramPName = eventId.includes('_') ? 'SportRadar' : 'BetFair';
          paramEId = eventId.includes('_')
            ? eventId.split('_').join(':')
            : eventId;
          fetchPremiummarketsByEventId(
            paramPName,
            paramSId,
            paramCId,
            paramEId,
            marketTime
          );
          if (!betFairWSConnected && (eventData?.matchOdds?.runners?.length > 0 || secondaryMatchOdds?.length > 0)) {
            connectToBFWS(topicUrls?.matchOddsBaseUrl);
          }
          if (!dreamWSConnected && (bmMData?.length > 0 || fmData?.length > 0)) {
            connectToDreamWS(topicUrls?.bookMakerBaseUrl);
          }
          if (!sportsRadarWSConnected && seEventData?.markets?.matchOdds?.length > 0) {
            connectToSRWS(topicUrls?.premiumBaseUrl);
          }
        }
      }
      console.log('Welcome back! Page is visible.', new Date(moment.now()));
    } else {
      console.log('User switched away. Page is hidden.', new Date(moment.now()));
    }
  }, [isVisible]);

  useEffect(() => {
    if (loggedIn && enableFetchOrders && selectedEvent.id) {
      setTimeout(() => {
        fetchOpenBets(selectedEvent?.id, selectedEventType?.id);
        fetchOpenBetsRisk(selectedEvent?.id);
      }, 1000);
    }
    // }, [loggedIn, triggerFetchOrders, fetchOpenOrders]);
  }, [loggedIn, triggerFetchOrders]);

  useEffect(() => {
    const [sportId, competitionId, eventId, marketTime] = atob(
      routeParams.eventInfo
    ).split(':');
    if (loggedIn && eventId && !backupStreamUrl) {
      fetchStreamUrl(sportId, competitionId, eventId);
    }
  }, [loggedIn, routeParams?.eventId]);

  // Fetch market prices from URL encoded param

  useEffect(() => {
    const [sportId, competitionId, eventId, marketTime] = atob(
      routeParams.eventInfo
    ).split(':');
    fetchEvent(sportId, competitionId, eventId, marketTime);
    if (loggedIn && routeParams?.eventId) {
      setEnableFetchOrders(true);
      fetchOpenBets(eventId, sportId);
      fetchOpenBetsRisk(eventId);
    }
    const providerName = eventId.includes('_') ? 'SportRadar' : 'BetFair';
    const sEventId = eventId.includes('_')
      ? eventId.split('_').join(':')
      : eventId;
    fetchPremiummarketsByEventId(
      providerName,
      sportId,
      competitionId,
      sEventId,
      marketTime
    );

    // setBettingInprogress(false);
    // if (bets[0]?.amount) {
    //   clearExchangeBets();
    // }
    // clearBetStatusResponse();
  }, [routeParams?.eventId]);

  useEffect(() => {
    if (eventData !== null) {
      fetchEvent(
        eventData?.sportId,
        eventData?.competitionId,
        eventData?.eventId,
        ''
      );
    }
  }, [triggerFetchMarkets]);

  useEffect(() => {
    if (eventData && eventData.status === 'IN_PLAY') {
      setTabVal(0);
    }
    if (totalOrders && !isMobile) {
      setTabVal(1);
    } else {
      setTabVal(0);
    }
  }, [totalOrders]);

  useEffect(() => {
    if (!openBetslip && bets.length > 0) {
      setOpenBetslip(true);
    }
  }, [bets]);

  const fetchStreamUrl = async (
    sportId: string,
    competitionId: string,
    eventId: string
  ) => {
    try {
      const response = await SVLS_API.get(`/catalog/v2/live-stream-links/`, {
        headers: {
          Authorization: sessionStorage.getItem('jwt_token'),
        },
        params: {
          providerId: PROVIDER_ID,
          sportId: sportId,
          competitionId: competitionId,
          eventId: eventId,
        },
      });

      if (response.status === 200 && response.data) {
        setBackupStreamUrl(response.data);
      } else {
        setBackupStreamUrl(null);
      }
    } catch (err) {
      setBackupStreamUrl(null);
    }
  };

  useEffect(() => {
    if (openBets?.length > 0 && !isMobile) setTabVal(1);
  }, [openBets?.length]);

  useEffect(() => {
    if (bets?.length > 0) setTabVal(0);
  }, [bets]);

  useEffect(() => {
    if (isPushNotificationConnected() && loggedIn && eventData?.eventId) {
      unsubscribePNWsforEvents(houseId);
      unsubscribePNWsforEvents(parentId);
      subscribeWsForNotifications(
        false,
        houseId,
        eventData?.sportId,
        eventData?.competitionId,
        eventData?.eventId
      );
      subscribeWsForNotificationsPerAdminAllMarkets(
        false,
        houseId,
        parentId,
        accountId,
        eventData?.eventId
      );
      return () => {
        unsubscribePNWsforEvents(houseId);
        unsubscribePNWsforEvents(parentId + ':' + eventData?.eventId);
        if (!window.location.pathname.includes('==')) {
          subscribeWsForNotificationsPerAdmin(
            false,
            houseId,
            parentId,
            accountId
          );
          subscribeWsForNotifications(false, houseId);
        }
      };
    }
  }, [isPushNotificationConnected(), loggedIn, eventData?.eventId]);

  useEffect(() => {
    if (loggedIn) {
      // let refreshInterval = setInterval(() => {
      if (topicUrls?.matchOddsBaseUrl) {
        const baseUrlsPayload = {
          matchOddsBaseUrl: topicUrls?.matchOddsBaseUrl,
          bookMakerAndFancyBaseUrl: topicUrls?.bookMakerBaseUrl,
          premiumBaseUrl: topicUrls?.premiumBaseUrl,
        };
        checkStompClientSubscriptions(baseUrlsPayload);
      }
      // }, 10000);
      // return () => {
      //   clearInterval(refreshInterval);
      // };
    }
  }, []);

  const getFormattedMaxLimit = (max: number) => {
    const num = Number(max / cFactor);
    const fMax = Number(Math.floor(num / 50) * 50);
    return fMax > 999 ? Number(fMax / 1000).toFixed() + 'K' : fMax.toFixed();
  };

  const getFormattedMinLimit = (min: number) => {
    const num = Number(min / cFactor);
    const fMin = Number(Math.ceil(num / 10) * 10);
    return fMin > 999 ? Number(fMin / 1000).toFixed() + 'K' : fMin.toFixed();
  };

  const getCompetitionSlug = (competitionName: string) => {
    return competitionName
      .toLocaleLowerCase()
      .replace(/[^a-z0-9]/g, ' ')
      .replace(/ +/g, ' ')
      .trim()
      .split(' ')
      .join('-');
  };

  const fetchOpenBetsRisk = async (eventId: string) => {
    try {
      if (!eventId || !loggedIn) {
        return;
      }

      const response = await SVLS_API.get(
        '/reports/v2/risk-management/user-risk',
        {
          headers: {
            Authorization: sessionStorage.getItem('jwt_token'),
          },
          params: {
            eventId: eventId,
          },
        }
      );
      setExposureMap(response.data.marketExposureMap);
    } catch (e) {
      console.log(e);
    }
  };

  useEffect(() => {
    updateBookMakerMarkets(bmMData);
  }, [bmMData]);

  // useEffect(() => {
  //   if (betStatusResponse === null) {
  //     return;
  //   }

  //   switch (betStatusResponse.status) {
  //     case 'IN_PROGRESS': {
  //       toast.info(
  //         <div>
  //           <InfoRounded />
  //           {betStatusResponse.message}
  //         </div>
  //       );
  //       break;
  //     }
  //     case 'SUCCESS': {
  //       toast.success(
  //         <div>
  //           <SuccessIcon />
  //           {betStatusResponse.message}
  //         </div>
  //       );
  //       if (addNewBet) {
  //         setFetchOpenOrders(moment.now());
  //       }
  //       fetchBalance();
  //       break;
  //     }
  //     case 'FAIL': {
  //       toast.error(
  //         <div>
  //           <ErrorIcon /> Bet failed - {betStatusResponse.message}
  //         </div>
  //       );
  //       break;
  //     }
  //   }

  //   setBettingInprogress(false);
  //   if (bets[0]?.amount) {
  //     clearExchangeBets();
  //   }
  //   clearBetStatusResponse();
  // }, [betStatusResponse]);

  // useEffect(() => {
  //   if (isFirstRender.current) {
  //     isFirstRender.current = false;
  //     return;
  //   }
  //   clearInterval(intervalRef.current);
  //   betStatus();
  // }, [triggerBetStatus]);

  // useEffect(() => {
  //   if (isFirstRenderStartTime.current) {
  //     isFirstRenderStartTime.current = false;
  //     return;
  //   }

  //   intervalRef.current = setInterval(() => {
  //     betStatus();
  //     clearInterval(intervalRef.current);
  //   }, BET_TIMEOUT);

  //   return () => clearInterval(intervalRef.current);
  // }, [startTime]);

  return (
    <div>
      <SEO
        title={BRAND_NAME}
        name={eventData?.eventName}
        description={eventData?.eventName}
        type={eventData?.eventName}
        link={''}
      />
      {eventData ? (
        <IonRow className="eam-ctn">
          {!virtualScorecard && scorecardID ? (
            <Script
              strategy="afterInteractive"
              dangerouslySetInnerHTML={scorecardScript}
            />
          ) : null}
          {/* Left Side compitation section */}
          <IonCol className="eam-competitions-menu-section competitions-menu-section">
            <div className="sticky-col">
              <CompetitionsMenu />
            </div>
          </IonCol>

          {/* Mobile stream & Openbets & scorecard */}
          <IonCol className="mob-stream-section">
            <IonRow className="eam-info-header eam-info-header-name">
              {/* <div>
                <NavLink className="eam-breadcrumb-link" to={`/exchange_sports/${SportNameByIdMap[eventData?.sportId] === "soccer" ? "football" : SportNameByIdMap[eventData?.sportId]}/${getCompetitionSlug(eventData?.competitionName)}`}>
                  {eventData?.competitionName}
                </NavLink> {"   "}
                / <span className="eam-event-name">{eventData?.eventName}</span></div>
              {!['7', '4339'].includes(selectedEventType?.id) ? (
                <div className="event-date">
                  {eventData ?
                    moment(eventData?.openDate).format("HH:mm, DD MMM")
                    : null}
                </div>
              ) : null} */}
              <div className="eam-competitions-name">
                {eventData?.competitionName}
              </div>
              <div className="eam-teams-name">
                <div className="eam-team-1">{eventData?.homeTeam}</div>
                <div className="eam-date-ctn">
                  <div className="eam-date">
                    {eventData ? (
                      <>
                        <div>
                          {moment(eventData?.openDate).format('DD MMM YYYY')}
                        </div>
                        <div>
                          {moment(eventData?.openDate).format('hh:mm A')}
                        </div>
                      </>
                    ) : null}
                  </div>
                </div>
                <div className="eam-team-2">{eventData?.awayTeam}</div>
              </div>
            </IonRow>

            {loggedIn &&
            isMobile &&
            (openBets.length > 0 ||
              (eventData && eventData.status === 'IN_PLAY')) ? (
              <>
                <Tabs
                  value={tabVal}
                  className="eam-all-markets-header-tabs"
                  onChange={(_, newValue) => {
                    setTabVal(newValue);
                  }}
                >
                  <Tab label="Scorecard" value={0} />
                  <Tab
                    label="Live Stream"
                    value={1}
                    disabled={!(eventData && eventData.status === 'IN_PLAY')}
                  />
                  <Tab label={`Open Bets (${totalOrders})`} value={2} />
                </Tabs>
                <TabPanel
                  value={tabVal}
                  index={0}
                  className="event-stat-mobile-ctn"
                >
                  <div>
                    {tabVal === 0 &&
                    eventData &&
                    eventData.matchOdds &&
                    eventData.status === 'IN_PLAY' ? (
                      <>
                        <Accordion
                          className="scorecard-accordion"
                          defaultExpanded={true}
                        >
                          <AccordionSummary
                            expandIcon={
                              <ExpandLessSharpIcon className="expand-icon" />
                            }
                            aria-controls="panel1a-content"
                            className="scorecard-header"
                          >
                            Live Score
                          </AccordionSummary>
                          <AccordionDetails className="scorecard-detail">
                            <div className="widgets">
                              <div>
                               
                              </div>
                              {virtualScorecard ? (
                                <iframe
                                  width="100%"
                                  id="frame"
                                  src={virtualScorecard}
                                  sandbox="allow-same-origin allow-forms allow-scripts allow-top-navigation allow-popups"
                                />
                              ): <div className="sr-widget sr-widget-1"></div>}
                            </div>
                          </AccordionDetails>
                        </Accordion>
                      </>
                    ) : null}
                  </div>
                </TabPanel>
                <TabPanel
                  value={tabVal}
                  index={1}
                  className="eam-header-tab-panel"
                >
                  {tabVal === 1 ? (
                    <>
                      <div className="live-stream-ctn">
                        {/* {eventData.sportId === '4' ? ( */}
                        <CricketLiveStream
                          eventID={eventData.eventId}
                          providerUrl={backupStreamUrl}
                        />
                      </div>
                    </>
                  ) : null}
                </TabPanel>
                <TabPanel
                  value={tabVal}
                  index={2}
                  className="event-stat-mobile-ctn"
                >
                  <div className="btn-background">
                    <div className="btn-mybets">
                      <NavLink to="/my_bets">
                        <Button>View All</Button>
                      </NavLink>
                    </div>
                  </div>
                  {openBets.length > 0 && loggedIn ? (
                    <ExchOpenBets />
                  ) : (
                    <>
                      <div className="no-bet-data mob-open-bets-ctn">
                        No open bets to show
                      </div>
                    </>
                  )}
                </TabPanel>
              </>
            ) : null}
          </IonCol>

          <IonCol className="eam-events-table-section">
            <IonRow className="eam-info-header eam-info-header-name">
              <div className="eam-competitions-name">
                {eventData?.competitionName}
              </div>
              <div className="eam-teams-name">
                <div className="eam-team-1">{eventData?.homeTeam}</div>
                <div className="eam-date-ctn">
                  <div className="eam-date">
                    {eventData ? (
                      <>
                        <div className="eam-dates">
                          <div>
                            {moment(eventData?.openDate).format('DD MMM YYYY')}
                          </div>
                          <div>
                            {moment(eventData?.openDate).format('hh:mm A')}
                          </div>
                        </div>
                        {/* <div className='eam-vs'>VS</div> */}
                      </>
                    ) : null}
                  </div>
                </div>
                <div className="eam-team-2">{eventData?.awayTeam}</div>
              </div>
            </IonRow>

            {loggedIn &&
            !isMobile &&
            eventData?.status === 'IN_PLAY' &&
            !['7', '4339'].includes(eventData.sportId) ? (
              <Accordion className="scorecard-accordion" defaultExpanded={true}>
                <AccordionSummary
                  expandIcon={<ExpandLessSharpIcon className="expand-icon" />}
                  aria-controls="panel1a-content"
                  className="scorecard-header"
                >
                  Live Score
                </AccordionSummary>
                <AccordionDetails className="scorecard-detail">
                  <div className="widgets">
                    <div>
                     
                    </div>
                    {virtualScorecard ? (
                      <iframe
                        width="100%"
                        id="frame"
                        src={virtualScorecard}
                        sandbox="allow-same-origin allow-forms allow-scripts allow-top-navigation allow-popups"
                      />
                    ): <div className="sr-widget sr-widget-1"></div>}
                  </div>
                </AccordionDetails>
              </Accordion>
            ) : null}

            <IonRow className="eam-table-section">
            {eventData.providerName.toLowerCase() !== 'sportradar' && (
              <MatchOddsTable
                exposureMap={exposureMap ? exposureMap : null}
                loggedIn={loggedIn}
                getFormattedMinLimit={getFormattedMinLimit}
                getFormattedMaxLimit={getFormattedMaxLimit}
                eventData={eventData}
                fetchEvent={fetchEvent}
                secondaryMatchOdds={secondaryMatchOdds}
              />
            )}
            </IonRow>

            {secondaryMarkets?.bookmakers?.length > 0 &&
            secondaryMarkets?.bookmakers[0]?.runners?.length > 0 ? (
              <>
                <IonRow className="eam-section-divider"></IonRow>
                <IonRow className="eam-table-section">
                  <BmMTable
                    loggedIn={loggedIn}
                    getFormattedMinLimit={getFormattedMinLimit}
                    getFormattedMaxLimit={getFormattedMaxLimit}
                    bmMData={bmMData}
                    eventData={eventData}
                    exposureMap={exposureMap ? exposureMap : null}
                    fetchEvent={fetchEvent}
                  />
                </IonRow>
              </>
            ) : null}

            <IonRow className="eam-table-section fancy-tab-section">
              {secondaryMarkets?.fancyMarkets?.length > 0 ||
              seEventData?.markets?.matchOdds?.length > 0 ? (
                <>
                  <Tabs
                    value={fancyTabVal}
                    className="fancy-market-tabs"
                    onChange={(_, newValue) => {
                      setFancyTabVal(newValue);
                    }}
                  >
                    {secondaryMarkets?.fancyMarkets?.length > 0 ? (
                      <Tab label="Fancy" className="fancy-tab" value={0} />
                    ) : null}
                    {/* {seEventData?.markets?.matchOdds?.length > 0 ? ( */}
                    <Tab
                      label={`Premium ` + selectedEventType.name}
                      className="fancy-tab premium-markets"
                      value={1}
                    />
                    {/* ) : null} */}
                  </Tabs>
                  <IonRow>
                    <TabPanel
                      value={fancyTabVal}
                      index={0}
                      className="fancy-tab-ctn"
                    >
                      {secondaryMarkets?.fancyMarkets?.length > 0 ? (
                        <>
                          <FMTable
                            loggedIn={loggedIn}
                            getFormattedMinLimit={getFormattedMinLimit}
                            getFormattedMaxLimit={getFormattedMaxLimit}
                            exposureMap={exposureMap ? exposureMap : null}
                            fetchEvent={fetchEvent}
                          />
                        </>
                      ) : null}
                    </TabPanel>

                    <IonRow className="row-100">
                      {' '}
                      <TabPanel
                        value={fancyTabVal}
                        index={1}
                        className="fancy-tab-ctn"
                      >
                        {seEventData?.markets?.matchOdds?.length > 0 ? (
                          <>
                            <PremiumMarketsView
                              loggedIn={loggedIn}
                              dreamData={eventData}
                              getFormattedMinLimit={getFormattedMinLimit}
                              getFormattedMaxLimit={getFormattedMaxLimit}
                            />
                          </>
                        ) : (
                          <div className="no-fancy-msg">No Premium Markets</div>
                        )}
                      </TabPanel>
                    </IonRow>
                  </IonRow>
                </>
              ) : null}
            </IonRow>
          </IonCol>

          {!isMobile ? (
            <IonCol className="stream-section">
              <div className="sticky-col">
                {loggedIn && eventData && eventData.status === 'IN_PLAY' ? (
                  <div className="stream-accordion">
                    <div className="stream-header">Live Stream</div>
                    <div className="stream-body">
                      {/* {streamAccordion ? (
                        <> */}
                      <div className="live-stream-ctn">
                        <CricketLiveStream
                          eventID={eventData.eventId}
                          providerUrl={backupStreamUrl}
                        />
                      </div>
                      {/* </>
                      ) : null} */}
                    </div>
                  </div>
                ) : null}

                <div className="bet-slip-open-bets-ctn">
                  <Tabs
                    value={tabVal}
                    className="eam-all-markets-header-tabs"
                    onChange={(_, newValue) => {
                      setTabVal(newValue);
                    }}
                  >
                    <Tab label={`Bet Slip (${bets.length})`} value={0} />
                    {/* <Tab
                      label="Live Stream"
                      value={1}
                      disabled={
                        !(
                          eventData &&
                          (eventData.inPlay || eventData.matchOdds.inplay)
                        )
                      }
                    /> */}
                    <Tab
                      label={'Open Bets (' + totalOrders + ')'}
                      value={1}
                      // disabled={openBets.length < 1}
                    />
                  </Tabs>

                  <TabPanel
                    value={tabVal}
                    index={0}
                    className="event-stat-mobile-ctn"
                  >
                    {bets.length > 0 && !isMobile ? (
                      <ExchBetslip
                        setBetStartTime={(date) => setStartTime(date)}
                        setAddNewBet={(val) => setAddNewBet(val)}
                      />
                    ) : (
                      <>
                        <div className="no-bet-data">
                          Place bet to see it here
                        </div>
                      </>
                    )}
                  </TabPanel>
                  <TabPanel
                    value={tabVal}
                    index={1}
                    className="event-stat-mobile-ctn"
                  >
                    <div className="btn-background">
                      <div className="btn-mybets">
                        <NavLink to="/my_bets">
                          <Button>View All</Button>
                        </NavLink>
                      </div>
                    </div>
                    {openBets.length > 0 && loggedIn ? (
                      <ExchOpenBets />
                    ) : (
                      <>
                        <div className="no-bet-data">No open bets to show</div>
                      </>
                    )}
                  </TabPanel>

                  {/* <div className="all-markets-promotions web-view">
                  <PromotionSidebar />
                </div> */}
                </div>
              </div>
            </IonCol>
          ) : null}
        </IonRow>
      ) : null}

      {/* WEB - Right sdie section(Stream & Betslip ) */}
      {bets.length > 0 ? (
        <div
          className={
            isIOS
              ? 'betslip-section ios-betslip mob-betslip-section'
              : 'betslip-section mob-betslip-section'
          }
        >
          <Accordion
            className="stream-accordion"
            expanded={openBetslip}
            onChange={(_, expanded) => setOpenBetslip(expanded)}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon className="expand-icon" />}
              aria-controls="panel1a-content"
              className="stream-header"
            >
              Bet Slip ({bets.length})
            </AccordionSummary>
            <AccordionDetails className="stream-body">
              {bets.length > 0 && isMobile ? (
                <ExchBetslip
                  setBetStartTime={(date) => setStartTime(date)}
                  setAddNewBet={(val) => setAddNewBet(val)}
                />
              ) : (
                <>
                  <div className="no-bet-data">Place bet to see it here</div>
                </>
              )}
            </AccordionDetails>
          </Accordion>
        </div>
      ) : null}
    </div>
  );
};

const mapStateToProps = (state: RootState, ownProps) => {
  const selectedEvent = state.exchangeSports.selectedEvent;

  return {
    eventData: getAllMarketsByEvent(
      state.exchangeSports.events,
      state.exchangeSports.selectedEventType.id,
      state.exchangeSports.selectedCompetition.id,
      selectedEvent.id
    ),
    secondaryMarkets: getSecondaryMarketsByEvent(
      state.exchangeSports.secondaryMarketsMap,
      selectedEvent.id
    ),
    secondaryMatchOdds: getSecondaryMatchOddsByEvent(
      state.exchangeSports.secondaryMatchOddsMap,
      selectedEvent.id
    ),
    bmMData: getBookmakerMarketsByEvent(
      state.exchangeSports.secondaryMarketsMap,
      selectedEvent.id
    ),

    seEventData: getPremiumMarkets(
      state.exchangeSports.premiumMarketsMap,
      selectedEvent.id
    ),
    lineMarkets: getLineMarketsByEvent(
      state.exchangeSports.secondaryMatchOddsMap,
      selectedEvent.id
    ),
    selectedEventType: state.exchangeSports.selectedEventType,
    selectedEvent: selectedEvent,
    bets: state.exchBetslip.bets,
    openBets: state.exchBetslip.openBets,
    totalOrders: state.exchBetslip.totalOrders,
    loggedIn: state.auth.loggedIn,
    streamUrl: state.common.streamUrl,
    topicUrls: state?.exchangeSports?.topicUrls,
    houseId: getHouseIdFromToken(),
    parentId: getParentIdFromToken(),
    accountId: sessionStorage.getItem('aid'),
    triggerFetchMarkets: state.exchangeSports.triggerFetchMarkets,
    triggerFetchOrders: state.exchangeSports.triggerFetchOrders,
    triggerBetStatus: state.exchangeSports.triggerBetStatus,
    betStatusResponse: state.exchBetslip.betStatusResponse,
    betFairWSConnected: state.exchangeSports.betFairWSConnected,
    dreamWSConnected: state.exchangeSports.dreamWSConnected,
    sportsRadarWSConnected: state.exchangeSports.sportsRadarWSConnected,
    fmData: getFancyMarketsByEvent(
      state.exchangeSports.secondaryMarketsMap,
      selectedEvent.id
    )
  };
};

const mapDispatchToProps = (dispatch: Function) => {
  return {
    clearExchcngeBets: () => dispatch(clearExchcngeBets()),
    updateBookMakerMarkets: (data: BookmakerDTO) =>
      dispatch(updateBookMakerMarkets(data)),
    fetchOpenBets: (eventId: string, sportId: string) =>
      dispatch(fetchOpenBets(eventId, sportId)),
    fetchEvent: (
      sportId: string,
      competitionId: string,
      eventId: string,
      marketTime: string
    ) => dispatch(fetchEvent(sportId, competitionId, eventId, marketTime)),
    fetchPremiummarketsByEventId: (
      providerId: string,
      competitionId: string,
      sportId: string,
      eventId: string,
      marketTime: string
    ) =>
      dispatch(
        fetchPremiummarketsByEventId(
          providerId,
          competitionId,
          sportId,
          eventId,
          marketTime
        )
      ),
    setExchEvent: (event: SelectedObj) => dispatch(setExchEvent(event)),
    updateEventScorecard: (scorecard: any) =>
      dispatch(updateEventScorecard(scorecard)),
    clearExchangeBets: () => dispatch(clearExchcngeBets()),
    setBettingInprogress: (val: boolean) => dispatch(setBettingInprogress(val)),
    clearBetStatusResponse: () => dispatch(clearBetStatusResponse()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ExchAllMarkets);
